import { initAutocomplete } from "./utils/address-autofill-utils";
import { isCurrentView } from "./utils/view-util";

const sbsaRoutes =
  ".sbsa-signup.business_location, .sbsa-portal.business_address, .payment_methods, .sbsa-portal.related_parties.shareholder";
const snapscanRoutes =
  ".signup.business_location, .portal.business_address, .payment_methods, .portal.card_machines.order, .home.index, .portal.related_parties.shareholder";
// Shared page initialization of autocomplete
document.addEventListener("DOMContentLoaded", function () {
  if (!isCurrentView(`${sbsaRoutes}, ${snapscanRoutes}`)) {
    return;
  }

  // Auto complete for address_form_fields partial
  let address1Field = document.getElementById("address1");
  let address2Field = document.getElementById("address2");
  let postalField = document.getElementById("postcode");
  let suburbField = document.getElementById("suburb");
  let cityField = document.getElementById("city");
  let provinceField = document.getElementById("province");

  initAutocomplete(
    address1Field,
    address2Field,
    postalField,
    suburbField,
    cityField,
    provinceField,
  );
});
